import React, { useEffect, useState } from "react"
import { useLocation } from "react-router"
import {
  EMAIL_LABEL_TEXT,
  EMAIL_MODAL_BODY_TEXT,
  EMAIL_MODAL_BUTTON_TEXT,
  EMAIL_MODAL_HEADING_TEXT,
  EMAIL_SENT_SUCCESS_TEXT,
  EMAIL_SENT_SUCCESS_TITLE,
  SENDING_EMAIL_TITLE
} from "../../constants"
import { FormInput, Loader, Modal } from "../../UIKit/components"
import {
  ButtonWrapper,
  ErrorText,
  InlineLink,
  ModalBodyWrapper,
  PageSection,
  ParagraphText,
  PrimaryButton,
  SuccessText,
} from "../../UIKit/styles"

export default function EmailLinkModal({
  isOpen,
  onModalClose,
  savedEmailAddress,
}) {
  const { search } = useLocation()
  const [showSuccess, setShowSuccess] = useState(false)
  const [sendingEmail, setSendingEmail] = useState(false)
  const [error, setError] = useState(null)
  const [emailAddress, setEmailAddress] = useState("")

  useEffect(() => {
    const setInitialEmailAddress = () => {
      setEmailAddress(savedEmailAddress)
    }
    setInitialEmailAddress()
  }, [savedEmailAddress])

  useEffect(() => {
    const resetModal = () => {
      setSendingEmail(false)
      setError(null)
      setShowSuccess(false)
    }
    resetModal()
  }, [isOpen])

  const sendEmail = async () => {
    try {
      setSendingEmail(true)
      setError(false)
      setShowSuccess(false)
      const urlSearchParams = new URLSearchParams(search)
      const kpin = urlSearchParams.get("kpin")
      const shareId = urlSearchParams.get("shareId")
      const response = await fetch(
        `${process.env.REACT_APP_CALC_API_URL}/kpins/${kpin}/shares/${shareId}?email=${emailAddress}`,
        {
          method: "POST",
        }
      )
      const { error } = await response.json()
      if (error) throw new Error(error)
      setShowSuccess(true)
    } catch (e) {
      setError(e.message)
    } finally {
      setSendingEmail(false)
    }
  }

  const getModalContent = () => {
    if(showSuccess) return             <SuccessText>{EMAIL_SENT_SUCCESS_TEXT}{emailAddress}</SuccessText>
    if(error) return <PageSection><ErrorText>{error}</ErrorText></PageSection>
   
    return (
      <>
       {EMAIL_MODAL_BODY_TEXT.map((text) => (
                <ParagraphText key={text}>{text}</ParagraphText>
              ))}
              <InlineLink
                href={`${window.location.origin}/results${search}`}
                target="_blank"
              >
                {`${window.location.origin}/results${search}`}
              </InlineLink>

              <PageSection>
                <FormInput
                  label={EMAIL_LABEL_TEXT}
                  id="email-link-input"
                  value={emailAddress || ""}
                  onChange={setEmailAddress}
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"
                />
              </PageSection>
               <ButtonWrapper alignButtons="center">
                <PrimaryButton onClick={sendEmail} disabled={!emailAddress}>
                  {EMAIL_MODAL_BUTTON_TEXT}
                </PrimaryButton>
              </ButtonWrapper>
      </>
    )
  }

  const getModalTitle = () => {
    if(sendingEmail) return SENDING_EMAIL_TITLE;
    if(showSuccess) return EMAIL_SENT_SUCCESS_TITLE;
    return EMAIL_MODAL_HEADING_TEXT
  }

  return (
    <Modal
      isOpen={isOpen}
      title={getModalTitle()}
      allowClose={!sendingEmail}
      onClose={onModalClose}
      body={
        <ModalBodyWrapper>
          {sendingEmail ? (
            <Loader />
          ) : (
            <>
              {getModalContent()}
             
            </>
          )}
        </ModalBodyWrapper>
      }
    />
  )
}
